"use client";

import { memo } from "react";
import { cn } from "@/lib/utils";

type Props = {
	userName?: string;
};

function TypingIndicator({ userName }: Props) {
	return (
		<li className="flex flex-col items-start">
			<div className="relative w-fit min-w-20 rounded-full bg-tertiary/80 px-4 py-2.5">
				<div className="flex items-center gap-1">
					<div className="flex gap-1">
						<div className={cn(
							"size-2 rounded-full bg-secondary-foreground/60 animate-bounce",
							"[animation-delay:0ms]"
						)} />
						<div className={cn(
							"size-2 rounded-full bg-secondary-foreground/60 animate-bounce",
							"[animation-delay:150ms]"
						)} />
						<div className={cn(
							"size-2 rounded-full bg-secondary-foreground/60 animate-bounce",
							"[animation-delay:300ms]"
						)} />
					</div>
					{userName && (
						<span className="ml-2 text-xs text-muted-foreground">
							{userName} is typing...
						</span>
					)}
				</div>
			</div>
		</li>
	);
}

export default memo(TypingIndicator);

